
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"26.4","height":"26.41"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Path 749"}},[_c('path',{attrs:{"data-name":"Path 751","d":"M26.403 13.21a1.423 1.423 0 01-.42 1.01 1.392 1.392 0 01-1.01.43h-10.33v10.33a1.451 1.451 0 01-1.44 1.43 1.423 1.423 0 01-1.01-.42 1.392 1.392 0 01-.43-1.01V14.65H1.433a1.443 1.443 0 01-1.02-2.45 1.5 1.5 0 011.02-.43h10.33V1.45a1.4 1.4 0 01.43-1.03 1.423 1.423 0 011.01-.42 1.455 1.455 0 011.44 1.45v10.32h10.33a1.458 1.458 0 011.43 1.44z","fill":"#28345c"}})])])
          )
        }
      }
    